import * as yup from 'yup';

const phoneRegExp = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

export const getCreateAccountManuallySchema = yup.object().shape({
  name: yup.string().required('Ce champs est requis'),
  legalStatutes: yup.string().required('Ce champs est requis'),
  plan: yup.string().required('Ce champs est requis'),
  address: yup.string().required('Ce champs est requis'),
  city: yup.string().required('Ce champs est requis'),
  postalCode: yup.string().required('Ce champs est requis'),
  department: yup.string().required('Ce champs est requis'),
  region: yup.string().required('Ce champs est requis'),
  latitude: yup.number(),
  longitude: yup.number(),
  siret: yup.string().required('Ce champs est requis'),
  tva: yup.string(),
  firstName: yup.string(),
  lastName: yup.string(),
  email: yup.string().email().required('Ce champs est requis'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Numéro de téléphone invalide')
    ,
  function: yup.string(),
});
